export function SkeletonBox({
  width,
  height,
  borderRadius = 8,
}: {
  width?: number | string;
  height?: number | string;
  borderRadius?: number;
}) {
  return (
    <div
      role="status"
      aria-label="Loading..."
      aria-busy="true"
      className="animate-pulse bg-[rgba(28,27,46,0.08)]"
      style={{ width: width ?? "100%", height: height ?? 20, borderRadius }}
    />
  );
}

export function SkeletonCircle({ size }: { size: number }) {
  return (
    <div
      role="status"
      aria-label="Loading..."
      aria-busy="true"
      className="animate-pulse bg-[rgba(28,27,46,0.08)]"
      style={{ width: size, height: size, borderRadius: size / 2 }}
    />
  );
}

export function StatsBarSkeleton() {
  return (
    <div
      role="status"
      aria-label="Loading stats..."
      aria-busy="true"
      className="flex md:flex-col md:divide-y md:divide-[rgba(28,27,46,0.1)]"
    >
      {Array.from({ length: 2 }, (_, i) => i).map((n) => (
        <div key={n} className="flex-1 flex flex-col items-center gap-1 py-3 md:py-3">
          <SkeletonBox width={32} height={22} />
          <SkeletonBox width={44} height={12} />
        </div>
      ))}
    </div>
  );
}

export function ActiveCompetitionsSkeleton() {
  return (
    <div
      role="status"
      aria-label="Loading active competitions..."
      aria-busy="true"
      className="flex flex-col gap-2"
    >
      {Array.from({ length: 3 }, (_, i) => i).map((n) => (
        <div
          key={n}
          className="bg-white rounded-[20px] border border-[rgba(28,27,46,0.2)] shadow-[1px_1px_0px_0px_#1c1b2e] overflow-hidden flex flex-row animate-pulse"
        >
          <div className="w-2 bg-[rgba(28,27,46,0.08)] border-r-2 border-text" />
          <div className="flex-1 p-4 flex flex-col gap-2">
            <SkeletonBox width="60%" height={18} />
            <SkeletonBox width="40%" height={12} />
          </div>
        </div>
      ))}
    </div>
  );
}

export function FriendsSkeleton() {
  return (
    <div
      role="status"
      aria-label="Loading friends..."
      aria-busy="true"
      className="flex flex-col gap-3 animate-pulse"
    >
      {Array.from({ length: 4 }, (_, i) => i).map((n) => (
        <div key={n} className="flex flex-row items-center gap-3">
          <SkeletonCircle size={36} />
          <SkeletonBox width="50%" height={14} />
        </div>
      ))}
    </div>
  );
}
